import {Component, input} from '@angular/core';
import {NotFoundComponent} from "../../not-found/not-found.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {SrmPointChecklist} from "../../../../generated-model/model";
import {PreLinePipe} from "../../pre-line.pipe";

@Component({
  selector: 'app-point-checklist-table',
  standalone: true,
  imports: [
    NotFoundComponent,
    ReactiveFormsModule,
    FormsModule,
    PreLinePipe
  ],
  templateUrl: './point-checklist-table.component.html',
  styleUrl: './point-checklist-table.component.scss'
})
export class PointChecklistTableComponent {
  checklist = input.required<SrmPointChecklist[]>();

  onRadioClick($event: MouseEvent) {
    $event.preventDefault();
  }
}
